module.exports = __webpack_public_path__ + "static/6M_2023_Financial_Reporting-f6784c002c3ff3954df6900e8f7dd002.pdf";